<template>
  <div class="section_wrap">
    <div class="head">
      <div class="head-center">
        <div class="title">
          <div class="title-text">活动图片</div>
        </div>
      </div>
      <div class="head-right"></div>
    </div>
    <div class="body">
      <div class="showcase">
        <div class="goods-list" v-if="list.length > 0">
          <div class="goods-item" v-for="(item, index) in list" :key="index">
            <div class="goods-item-img">
              <template>
                <div class="goods-img" @click="todetail(item, index)" v-if="item.cover">
                  <el-image class="image" :src="item.cover" @error="handleError" />
                </div>
                <div class="default-img" @click="todetail(item, index)" v-else>
                  <el-image class="image" :src="goodsimage" />
                </div>
              </template>
            </div>
            <div class="goods-item-info">
              <div class="title multiple">{{ item.title }}</div>
            </div>
          </div>
        </div>
        <div class="no-data" v-else>~暂无数据~</div>
        <div class="more-contain" v-if="isMore">
          <div class="more" @click="handleMore">
            <div class="more-title">更多</div>
            <div class="more-icon">
              <el-image class="elimage" :src="moreicon" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "search-album",
  components: {},
  props: {
    list: {
      type: Array,
      default: () => new Array(),
    },
    isMore: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      moreicon: require("@/assets/home/open.png"),
      goodsimage: require("@/assets/default/image02.jpg"),
    }
  },
  computed: {},
  mounted () {
  },
  methods: {
    handleError (e) {
      // 当图片加载失败时，将图片地址设置为默认图片
      e.target.src = this.goodsimage
      // 可以添加额外的处理，比如提示用户或者进行日志记录
    },
    handleMore () {
      this.$emit("more", 2)
    },
    todetail (item, inx) {
      window.localStorage.setItem("menuId", 3)
      this.$store.dispatch("setmenuid", 3)
      this.$router.push({
        path: "/home/album/detail",
        query: {
          id: item.id,
          index: inx,
          cPage: 1
        },
      })
    },
  },
};
</script>
<style scoped lang="scss">
.section_wrap {
  width: 100%;
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 40px;
    margin-bottom: 25px;
    .head-left {
      width: 64px;
    }
    .head-center {
      // flex: 1;
      .title {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
        .title-icon {
          width: 32px;
          min-width: 32px;
          height: 32px;
          margin-left: 10px;
          .elimage {
            width: 100%;
            height: 100%;
          }
        }
        .title-text {
          color: #000;
          font-size: 30px;
          font-weight: bold;
          line-height: 40px;
        }
      }
    }
    .head-right {
      .more {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height: 40px;
        margin-left: 15px;
        .elimage {
          width: 38px;
          height: 38px;
        }
      }
    }
  }
  .body {
    .showcase {
      margin: 0 -10px;
      .goods-list {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        .goods-item {
          width: calc((100% - 120px) / 5);
          height: 200px;
          background-color: #fff;
          border: 1px solid transparent;
          // box-shadow: 0px 0px 29px 0px rgb(0 80 179 / 8%);
          border-radius: 5px;
          overflow: hidden;
          position: relative;
          margin: 10px 10px;
          flex-shrink: 1;
          cursor: pointer;
          // &:hover {
          //   border: 1px solid rgb(9, 235, 178);
          // }
          .goods-item-img {
            width: 100%;
            height: 100%;
            position: relative;
            .goods-img {
              width: 100%;
              height: 100%;
              background: aliceblue;
              .image {
                display: inline-block;
                -webkit-transition-duration: 0.3s;
                transition-duration: 0.3s;
                -webkit-transition-property: transform;
                transition-property: transform;
                -webkit-transform: translateZ(0);
                transform: translateZ(0);
                box-shadow: 0 0 1px rgba(0, 0, 0, 0);
              }

              .image:hover,
              .image:focus,
              .image:active {
                -webkit-transform: scale(1.1);
                transform: scale(1.1);
              }

              .image {
                width: 100%;
                height: 100%;
              }
            }
            .default-img {
              width: 100%;
              height: 100%;
              // background: #daebfc;
              text-align: center;
              background: aliceblue;
              .image {
                display: inline-block;
                -webkit-transition-duration: 0.3s;
                transition-duration: 0.3s;
                -webkit-transition-property: transform;
                transition-property: transform;
                -webkit-transform: translateZ(0);
                transform: translateZ(0);
                box-shadow: 0 0 1px rgba(0, 0, 0, 0);
              }
              .image:hover,
              .image:focus,
              .image:active {
                -webkit-transform: scale(1.1);
                transform: scale(1.1);
              }
              .image {
                width: 100%;
                height: 100%;
              }
            }
          }
          .goods-item-info {
            width: 100%;
            height: 45px;
            line-height: 45px;
            padding: 0 15px;
            background: rgba(0, 0, 0, 0.5);
            position: absolute;
            left: 0;
            bottom: 0;
            .title {
              color: #fff;
              font-size: 16px;
              font-weight: 400;
            }
          }
        }
      }
      .no-data {
        height: 60px;
        line-height: 60px;
        text-align: center;
      }
      .more-contain {
        .more {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 28px;
          padding: 2px 20px;
          user-select: none;
          cursor: pointer;
          .more-title {
            color: #005292;
            font-size: 14px;
            font-weight: 400;
          }
          .more-icon {
            margin-left: 10px;
            .elimage {
              width: 12px;
              height: 12px;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 640px) {
  .section_wrap {
    .head {
      .head-center {
        .title {
          .title-icon {
            width: 18x;
            height: 18px;
          }
          .title-text {
            font-size: 18px;
          }
        }
      }
      .head-right {
        .more {
          margin-left: 5px;
          .elimage {
            width: 20px;
            height: 20px;
          }
        }
      }
    }
    .body {
      .showcase {
        margin: 0;
        .goods-list {
          .goods-item {
            width: calc((100% - 26px) / 2);
            margin: 5px 5px;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 640px) and (max-width: 1200px) {
  .section_wrap {
    .head {
      .head-center {
        .title {
          .title-icon {
            width: 24px;
            height: 24px;
          }
          .title-text {
            font-size: 24px;
          }
        }
      }
      .head-right {
        .more {
          margin-left: 10px;
          .elimage {
            width: 26px;
            height: 26px;
          }
        }
      }
    }
    .body {
      .showcase {
        .goods-list {
          .goods-item {
            width: calc((100% - 90px) / 4);
            margin: 10px 10px;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1200px) {
  .section_wrap {
    .head {
      .head-center {
        .title {
          .title-icon {
            width: 32px;
            height: 32px;
          }
          .title-text {
            font-size: 30px;
          }
        }
      }
      .head-right {
        .more {
          .elimage {
            width: 38px;
            height: 38px;
          }
        }
      }
    }
    .body {
      .showcase {
        .goods-list {
          .goods-item {
            width: calc((100% - 120px) / 5);
            margin: 10px 10px;
          }
        }
      }
    }
  }
}
</style>
